const NON_DESTINATION_PREFIXES: readonly string[] = Object.freeze([
	'/login',
	'/invitation/',
	'/password/forgotten',
	'/password/reset/',
]);

type FromLocation = { pathname: string; search: string; hash: string };

const isFromLocation = (value: unknown): value is FromLocation => {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const candidate = value as Record<string, unknown>;

	return typeof candidate.pathname === 'string';
};

/**
 * Resolves where to send a visitor once signed in: the page they were bounced from, or `'/'`.
 * The rules mirror the server-side `IsRelativePath` validator, since the same string can be sent as the SSO `redirectPath`.
 */
const resolvePostLoginDestination = (state: unknown): string => {
	if (typeof state !== 'object' || state === null || !('from' in state)) {
		return '/';
	}

	const { from } = state;

	if (!isFromLocation(from)) {
		return '/';
	}

	const search = typeof from.search === 'string' ? from.search : '';
	const hash = typeof from.hash === 'string' ? from.hash : '';
	const destination = `${from.pathname}${search}${hash}`;

	if (!destination.startsWith('/') || destination.startsWith('//')) {
		return '/';
	}

	if (destination.includes('\\') || destination.includes('://')) {
		return '/';
	}

	if (NON_DESTINATION_PREFIXES.some((prefix) => from.pathname.startsWith(prefix))) {
		return '/';
	}

	return destination;
};

export default resolvePostLoginDestination;
